import { motion } from "framer-motion";
import { FaRegHandshake, FaSearchDollar, FaRocket, FaChartBar } from "react-icons/fa";
import "../styles/workflow.css";

function Workflow() {
  const steps = [
    {
      title: "Kapcsolatfelvétel",
      icon: <FaRegHandshake size={28} />, 
      description:
        "Írsz nekem néhány mondatot a vállalkozásodról, a céljaidról, és arról, hogy miben szeretnél fejlődni. Ha úgy látom, hogy tudok segíteni, egyeztetünk egy rövid, ismerkedő konzultációt (ingyenes és kötelezettségmentes).",
    },
    {
      title: "Átvilágítás és javaslat",
      icon: <FaSearchDollar size={28} />, 
      description:
        "Átnézem, hogy eddig hogyan hirdettél (ha hirdettél), és megnézem, hol vannak a növekedés lehetőségei. Kapsz egy világos képet arról, mit tudna neked hozni a célzott online marketing.",
    },
    {
      title: "Indulás – kampányok beállítása",
      icon: <FaRocket size={28} />, 
      description:
        "Előkészítem a hirdetéseket, beállítom a kampányokat, és elindulunk. Az első időszakban a cél: minél gyorsabban adatokat gyűjteni, és megtalálni azokat az üzeneteket, ajánlatokat, célcsoportokat, amik működnek.",
    },
    {
      title: "Folyamatos optimalizálás",
      icon: <FaChartBar size={28} />, 
      description:
        "A kampány nem „eldurran és kész”. Hetente figyelem az eredményeket, javítok a hirdetéseken, és abból építkezem, amit a piac visszajelez. Így egyre olcsóbban, egyre hatékonyabban tudunk eredményeket elérni.",
    },
  ];

  return (
    <section className="workflow-section pt-5 my-0" id="workflow">
      <div className="container pb-4">
        <div className="text-center mb-5">
          <h2 className="section-heading text-uppercase">Hogyan dolgozunk együtt?</h2>
          <h3 className="section-subheading text-muted">
            A marketing nem varázslat, hanem folyamat. Lépésről lépésre haladunk – átláthatóan, érthetően és mérhetően.
          </h3>
        </div>
        <ul className="timeline">
          {steps.map((step, index) => (
            <motion.li
              key={index}
              className={`timeline-item ${index % 2 !== 0 ? "timeline-inverted" : ""}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <div className="timeline-image">
                <div className="icon-wrapper">
                  {step.icon}
                </div>
              </div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4 className="subheading text-center">{step.title}</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-justify text-center">{step.description}</p>
                </div>
              </div>
            </motion.li>
          ))}
        </ul>
      </div>

      <div className="curved-divider-workflow">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path
            fill="#2C2F36"
            d="M0,70 C360,100 1080,0 1440,70 L1440,100 L0,100 Z"
          />
        </svg>
      </div>
    </section>
  );
}

export default Workflow;